<template>
  <InputAddress
      v-model="data"
      :db-override="db"
      :question-override="question"
      :jsErrorsData="jsErrors"
      @jsErrors="jsErrors=$event"
  />
</template>

<script>
import InputAddress from "../../../inputs/InputAddress";

export default {
  name: 'ExistingPropertyAddress',
  components: {InputAddress},
  props: {
    value: {
      type: Object,
      required: false
    },
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'What is the address of your existing property?',
        subtitle:'Enter a postcode or the first line of an address to search.'
      },
      db: {
        saveLocation: 'mortgage_survey_existing_property_address',
        saveField: 'existing_address',
        deleteLocation: 'mortgage_survey_existing_property_address'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
      show: this.$parent.$parent.$data.show
    }
  }
}
</script>